import EventsAwardsDTALogoMenu from "@dta/components/EventsAwardsDTALogoMenu";
import EventsAwardsEELogoMenu from "@ee/components/EventsAwardsEELogoMenu";
import { AwardType } from "@events-awards/utils/types";

export const EventsAwardsLayoutFactory = (awardType: AwardType) => {
  switch (awardType) {
    case AwardType.EE:
      return EventsAwardsEELogoMenu;

    case AwardType.DATA:
      return EventsAwardsDTALogoMenu;
  }
};
